import {useFormContext} from "react-hook-form";
import {useLocation} from "react-router-dom";
import {useGoogleCalendarConnection} from "../../react-query-hooks/connect-calendar/useGoogleCalendarConnection";
import {writeFormSnapshot} from "./form-snapshot";
import {writeOAuthReturnIntent} from "./oauth-return-intent";

export function useConnectGoogleCalendarAndResume() {
  const {getValues} = useFormContext();
  const location = useLocation();
  const {connect, isConnecting} = useGoogleCalendarConnection();

  function connectAndResume() {
    writeFormSnapshot(location.pathname, getValues());
    writeOAuthReturnIntent(location.pathname + location.search);
    connect();
  }

  return {connectAndResume, isConnecting};
}
